export default {
  resources: {}
};



// WEBPACK FOOTER //
// ./public/sites/initialState.js